export { default } from "bullitttime-embermodelsevent/models/intermediate-timing-record";
